import react,{useCallback, useEffect,useState} from "react";

// Router:
import { Link, useNavigate, useParams } from 'react-router';

// Page Components
import FavoriteButton from "../UI Components/Buttons/FavoriteButton";
import BackButton from "../UI Components/Buttons/BackButton";

// MUI Components
import Box    from '@mui/material/Box';
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Badge, { badgeClasses } from '@mui/material/Badge';

// context
import { useFavorites } from "../../Context/FavoritesContext";
import { useAppData,useAppDataDispatch } from "../../Context/AppDataContext";



// Icons:
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';

// Utils
import { handleCompDisplay } from "../../utility/utils";


/******************************************************
 * Component Style
******************************************************/
import { styled } from '@mui/material/styles';
import { useLocation } from "react-router";

    const FilterButton =  styled(Button)({
             height:'100%',
            //  width:'auto',
             alignSelf:'end'
               
    });

    const FilterBadgeBtn =  styled(Badge) ({
            height:'100%',
             alignSelf:'end',
             border: 'solid'     
    })

    const FavBadgeButton =  styled(Button)({
        marginLeft:'0.5rem'
    });


    const ToolbarContainer = styled(Box)({
        display:'flex',
        flexDirection:'row',
        justifyContent:'end',
        paddingLeft:'0.5rem',
        paddingTop:'0.5rem',
        paddingBottom:'0.5rem',

        [`& ${FilterButton}`]:{ },

        [`& ${FavBadgeButton}`]:{

        }
        
    });

// const CartBadge = styled(Badge)`
//   & .${badgeClasses.badge} {
//     top: -16px;
//     right: -3px;
//   }
// `;


function PageToolbar({onFilterClick}) {

    const navigate     = useNavigate(),
         favoritesList = useFavorites(),
          appData       = useAppData();
    const curLocation = useLocation();
    // state
    const [currLoc,setCurrLoc]        = useState(curLocation);
    const [btnSetting, setBtnSetting] = useState({
        bBackVisible: false,
        bFavVisible: true,
        bFltrVisible: true
    });

    useEffect(() => {

        let nBtnSetting = {};

        switch(currLoc.pathname) {
            case '/':
            nBtnSetting = { bBackVisible: false, bFavVisible: true, bFltrVisible: true }
            setBtnSetting(nBtnSetting );
            break;

            case '/favorites':
            nBtnSetting = { bBackVisible: true, bFavVisible: false, bFltrVisible: false }
            setBtnSetting(nBtnSetting );
            break;

            case '/about':
            nBtnSetting = { bBackVisible: true, bFavVisible: false, bFltrVisible: false }
            setBtnSetting(nBtnSetting );
            break;

            default: //
        }
        setCurrLoc(curLocation); 
    },[curLocation,currLoc.pathname]);


/******************************************************
 * Event handling
******************************************************/
    const onFavoriteClick = (oEvent) => {
        navigate('/favorites');
    }



/******************************************************
 * Internal Methods
******************************************************/

    // const _handleBtnDisplay = (sParam) => {

    //     let disp;

    //     switch(sParam) {

    //         case 'tlbr.backBtn':
    //             switch(currLoc.pathname) {
    //                 case '/': disp = 'none'; break;
    //                 default : disp= 'flex'
    //             }
    //         break;

    //         case 'tlbr.favBtn':
    //             switch(currLoc.pathname) {
    //                 case '/'         : disp = 'flex'; break;
    //                 case '/favorites': disp = 'none'; break;
    //                 case '/about'    : disp = 'none'; break;
    //                 case '/contact'  : disp = 'none'; break;
    //                 case '/newItem'   : disp = 'none'; break;
    //                 default: //
    //             }
    //         break;

    //         case 'tlbr.fltBtn':
    //             switch(currLoc.pathname) {
    //                 case '/'         : disp = 'flex'; break;
    //                 case '/favorites': disp = 'none'; break;
    //                 case '/about'    : disp = 'none'; break;
    //                 case '/contact'  : disp = 'none'; break;
    //                 case '/newItem'   : disp = 'none'; break;
    //                 default: //
    //             }
    //         break;
    //     }
    //     return disp;
    // }

    return(
        <ToolbarContainer>
            <BackButton disableGutters
                sxStyle={{
                    display: () => handleCompDisplay('tlbr.backBtn',currLoc.pathname),
                    height:'2.1rem',
                    padding:0
                }}>
            </BackButton>

            {/* create Button */}
            {/* user login button */}

            <FavBadgeButton 
                variant="outlined" 
                onClick={onFavoriteClick}
                sx={{display:() => handleCompDisplay('tlbr.favBtn',currLoc.pathname) }}
            >
            <FavoriteIcon />
                {favoritesList.length}
            </FavBadgeButton>
            
        {/* <FilterBadgeBtn color="info" variant="dot" invisible={false}>
          <TuneOutlinedIcon/>
        </FilterBadgeBtn> */}
        
            <FilterButton 
                variant="outlined" 
                onClick={ (oEvent) => onFilterClick('fltr',oEvent) } 
                sx={{display: () => handleCompDisplay('tlbr.fltBtn',currLoc.pathname)  }}
                >
                   <TuneOutlinedIcon/>
            </FilterButton>
        </ToolbarContainer>

    );
}

export default PageToolbar;
